
import EnjinCoin from "../../../assets/filled/EnjinCoin.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EnjinCoinIcon({ className, dataTestid = "EnjinCoinIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <EnjinCoin data-testid={dataTestid} className={classes} {...rest} />
  );
}
